import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";
import "dayjs/locale/ja";
dayjs.locale("ja");

export default {
  name: "attendace-date-detail",
  components: {
    AppHeader
  },
  created() {
    this.getAttendanceDateDetail();
  },
  data() {
    return {
      attendanceType: "",
      attendance: "",
      attendanceEnd: false,
      attendanceContents: [],
      leaveReason: "",
      isLeaveForceApproval: "",
      forSiteSelectIndex: "",
      forDeleteIndex: "",
      searchSiteWord: "",
      sites: "",
      getSites: false,
      cars: "",
      getCars: false,
      savingFlag: false
    };
  },
  computed: {
    formatDate() {
      return dayjs(this.$route.params.date).format("YYYY年MM月DD日(ddd)");
    }
  },
  methods: {
    async getAttendanceDateDetail() {
      let data = {
        user_id: this.$route.params.user_id,
        date: this.$route.params.date
      };
      let res = await this.$store
        .dispatch("GET_ATTENDANCE_DATE_DETAIL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.attendance = res.attendance;
      this.attendanceType = this.attendance.attendance_type;
      // 休暇理由を取得
      this.leaveReason = "";
      this.isLeaveForceApproval = "";
      if (
        this.attendanceType === "half_day_leave" ||
        this.attendanceType === "paid_leave" ||
        this.attendanceType === "special_leave" ||
        this.attendanceType === "transfer_leave"
      ) {
        let leave_reason_data = {
          leave_date: this.$route.params.date,
          user_id: this.$route.params.user_id
        };
        let res_leave_reason = await this.$store
          .dispatch("CHECK_LEAVE_REASON", { data: leave_reason_data })
          .catch(err => {
            console.log(err);
            return;
          });
        if (res_leave_reason.approval_leave) {
          this.leaveReason = res_leave_reason.approval_leave.request_reason;
          if (res_leave_reason.approval_leave.discarded_at) {
            this.isLeaveForceApproval = "※強制承認されています";
          }
        }
      }
      // 休暇理由取得終わり
      if (this.attendance.attendance) {
        for (let i = 0; i < this.attendance.attendance.length; i++) {
          let wk_contents = {
            site_id: "",
            site_name: "",
            site_number: "",
            start_hh: "",
            start_mm: "",
            end_hh: "",
            end_mm: "",
            is_not_work: 0,
            is_use_car: 0,
            car_number: "",
            is_highway_use: 0,
            content: ""
          };
          wk_contents.site_id = this.attendance.attendance[i].site_id;
          wk_contents.site_name = this.attendance.attendance[i].name;
          wk_contents.site_number = this.attendance.attendance[i].site_number;
          wk_contents.start_hh = this.attendance.attendance[i].start_hh;
          wk_contents.start_mm = this.attendance.attendance[i].start_mm;
          wk_contents.end_hh = this.attendance.attendance[i].end_hh;
          wk_contents.end_mm = this.attendance.attendance[i].end_mm;
          wk_contents.is_not_work = this.attendance.attendance[i].is_not_work;
          if (this.attendance.attendance[i].car_number) {
            wk_contents.is_use_car = 1;
          } else {
            wk_contents.is_use_car = 0;
          }
          wk_contents.car_number = this.attendance.attendance[i].car_number;
          wk_contents.is_highway_use = this.attendance.attendance[
            i
          ].is_highway_use;
          wk_contents.content = this.attendance.attendance[i].content;
          this.attendanceContents.push(wk_contents);
        }
      }
      this.getCar();
      this.attendanceEnd = true;
    },
    changeAttendanceType() {
      this.attendanceContents = [];
    },
    openSiteSelectModal(index) {
      this.$bvModal.show("modal-work");
      this.forSiteSelectIndex = index;
    },
    async getSite() {
      this.getSites = false;
      let data = {
        company_id: this.attendance.company_id,
        is_construction_done: 0,
        search_word: this.searchSiteWord
      };
      let res = await this.$store
        .dispatch("GET_SITE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.sites = res.sites;
      this.getSites = true;
    },
    async getCar() {
      this.getCars = false;
      let data = {
        company_id: this.attendance.company_id,
        is_forward_hide: 0
      };
      let res = await this.$store
        .dispatch("GET_CAR", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.cars = res.cars;
      this.getCars = true;
    },
    siteDecision(siteId, siteName, siteNumber) {
      this.attendanceContents[this.forSiteSelectIndex].site_id = siteId;
      this.attendanceContents[this.forSiteSelectIndex].site_name = siteName;
      this.attendanceContents[this.forSiteSelectIndex].site_number = siteNumber;
      this.forSiteSelectIndex = "";
      this.$bvModal.hide("modal-work");
    },
    canStartTimeHh(index) {
      let startValue = "";
      startValue = 0;
      let endValue = "";
      if (
        this.attendanceContents[index].end_hh != "" &&
        (this.attendanceContents[index].end_mm != "" ||
          this.attendanceContents[index].end_mm == 0)
      ) {
        if (this.attendanceContents[index].end_mm == 0) {
          endValue = this.attendanceContents[index].end_hh - 1;
        } else {
          endValue = this.attendanceContents[index].end_hh;
        }
      } else if (
        index != this.attendanceContents.length - 1 &&
        this.attendanceContents[index + 1].end_hh != "" &&
        (this.attendanceContents[index + 1].end_mm != "" ||
          this.attendanceContents[index].end_mm == 0)
      ) {
        if (this.attendanceContents[index + 1].start_mm == 0) {
          endValue = this.attendanceContents[index + 1].start_hh - 1;
        } else {
          endValue = this.attendanceContents[index + 1].start_hh;
        }
      } else {
        endValue = 31;
      }
      let options = [];
      let wkHash = {};
      let wkText = "";
      for (let i = startValue; i <= endValue; i++) {
        if (i < 10) {
          wkText = ("0" + i).slice(-2);
        } else if (i >= 25) {
          wkText = "翌" + (i - 24);
        } else {
          wkText = i;
        }
        wkHash = {
          text: wkText,
          value: i
        };
        options.push(wkHash);
      }
      return options;
    },
    startHhChange(index) {
      this.attendanceContents[index].start_mm = "";
    },
    canStartTimeMm() {
      return [
        { text: "未選択", value: "" },
        { text: "00", value: 0 },
        { text: "30", value: 30 }
      ];
    },
    canEndTimeHh(index) {
      let startValue = "";
      if (
        this.attendanceContents[index].start_hh != "" &&
        (this.attendanceContents[index].start_mm != "" ||
          this.attendanceContents[index].start_mm == 0)
      ) {
        if (this.attendanceContents[index].start_mm == 0) {
          startValue = this.attendanceContents[index].start_hh;
        } else {
          startValue = this.attendanceContents[index].start_hh + 1;
        }
      }
      let endValue = "";
      if (index == this.attendanceContents.length - 1) {
        endValue = 32;
      } else {
        if (
          this.attendanceContents[index].end_hh != "" &&
          this.attendanceContents[index].end_mm != ""
        ) {
          if (this.attendanceContents[index].end_mm == 0) {
            endValue = this.attendanceContents[index].end_hh;
          } else {
            endValue = this.attendanceContents[index].end_hh + 1;
          }
        } else {
          endValue = 32;
        }
      }
      let options = [];
      let wkHash = {};
      let wkText = "";
      wkHash = {
        text: "未選択",
        value: wkText
      };
      options.push(wkHash);
      for (let i = startValue; i <= endValue; i++) {
        if (i < 10) {
          if (i == 0) {
            wkText = "00";
          } else {
            wkText = ("0" + i).slice(-2);
          }
        } else if (i >= 25) {
          wkText = "翌" + (i - 24);
        } else {
          wkText = i;
        }
        if (i == 0) {
          wkHash = {
            text: wkText,
            value: 0
          };
        } else {
          wkHash = {
            text: wkText,
            value: i
          };
        }
        options.push(wkHash);
      }
      return options;
    },
    canEndTimeMm(index) {
      if (this.attendanceContents[index].end_hh == 32) {
        return [
          { text: "未選択", value: "" },
          { text: "00", value: 0 }
        ];
      } else if (
        this.attendanceContents[index].start_hh != "" &&
        (this.attendanceContents[index].start_mm != "" ||
          this.attendanceContents[index].start_mm == 0) &&
        this.attendanceContents[index].start_hh ==
          this.attendanceContents[index].end_hh
      ) {
        return [
          { text: "未選択", value: "" },
          { text: "30", value: 30 }
        ];
      } else {
        return [
          { text: "未選択", value: "" },
          { text: "00", value: 0 },
          { text: "30", value: 30 }
        ];
      }
    },
    endHhChange(index) {
      this.attendanceContents[index].end_mm = "";
    },
    endMmChange(index) {
      if (index != this.attendanceContents.length - 1) {
        this.attendanceContents[index + 1].start_hh = this.attendanceContents[
          index
        ].end_hh;
        this.attendanceContents[index + 1].start_mm = this.attendanceContents[
          index
        ].end_mm;
      }
    },
    addContents() {
      let attendanceContent = {};
      if (this.attendanceContents.length == 0) {
        attendanceContent = {
          site_id: "",
          site_name: "",
          site_number: "",
          start_hh: 0,
          start_mm: 0,
          end_hh: "",
          end_mm: "",
          is_not_work: 0,
          is_use_car: 0,
          car_number: "",
          is_highway_use: 0,
          content: ""
        };
      } else {
        attendanceContent = {
          site_id: "",
          site_name: "",
          site_number: "",
          start_hh: this.attendanceContents[this.attendanceContents.length - 1]
            .end_hh,
          start_mm: this.attendanceContents[this.attendanceContents.length - 1]
            .end_mm,
          end_hh: "",
          end_mm: "",
          is_not_work: 0,
          is_use_car: 0,
          car_number: "",
          is_highway_use: 0,
          content: ""
        };
      }
      this.attendanceContents.push(attendanceContent);
    },
    removeContents(index) {
      this.$bvModal.show("delete_modal");
      this.forDeleteIndex = index;
    },
    removeContentsModal() {
      this.$bvModal.hide("delete_modal");
      if (this.attendanceContents.length - 1 > this.forDeleteIndex) {
        this.attendanceContents[
          this.forDeleteIndex + 1
        ].start_hh = this.attendanceContents[this.forDeleteIndex - 1].end_hh;
        this.attendanceContents[
          this.forDeleteIndex + 1
        ].start_mm = this.attendanceContents[this.forDeleteIndex - 1].end_mm;
      }
      this.attendanceContents.splice(this.forDeleteIndex, 1);
      this.forDeleteIndex = "";
    },
    validationError(index) {
      let regex = new RegExp(/^[0-9]+$/);
      if (this.attendanceContents.length > 0) {
        if (
          ((this.attendanceContents[index].is_not_work == 0 &&
            this.attendanceContents[index].site_id) ||
            this.attendanceContents[index].is_not_work == 1) &&
          regex.test(this.attendanceContents[index].start_hh) &&
          regex.test(this.attendanceContents[index].start_mm) &&
          regex.test(this.attendanceContents[index].end_hh) &&
          regex.test(this.attendanceContents[index].end_mm) &&
          ((this.attendanceContents[index].is_not_work == 0 &&
            ((this.attendanceContents[index].is_use_car == 1 &&
              this.attendanceContents[index].car_number) ||
              this.attendanceContents[index].is_use_car == 0) &&
            (this.attendanceContents[index].is_highway_use == 0 ||
              this.attendanceContents[index].is_highway_use == 1)) ||
            this.attendanceContents[index].is_not_work == 1) &&
          ("0" + this.attendanceContents[index].start_hh).slice(-2) +
            ("0" + this.attendanceContents[index].start_mm).slice(-2) <
            ("0" + this.attendanceContents[index].end_hh).slice(-2) +
              ("0" + this.attendanceContents[index].end_mm).slice(-2)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    validationErrorAll() {
      for (let i = 0; i < this.attendanceContents.length; i++) {
        if (this.validationError(i)) {
          return true;
        }
      }
      if (
        this.attendanceContents.length > 0 &&
        this.attendanceContents[this.attendanceContents.length - 1]
          .is_not_work == 1
      ) {
        return true;
      } else if (
        this.attendanceType == "work" &&
        this.attendanceContents.length == 0
      ) {
        return true;
      } else if (
        (this.attendanceType === "half_day_leave" || 
        this.attendanceType === "paid_leave" ||
        this.attendanceType === "special_leave" ||
        this.attendanceType === "transfer_leave") &&
        !this.leaveReason
      ) {
        return true;
      } else {
        return false;
      }
    },
    updateAttendanceContentRegistered() {
      this.$bvModal.show("modal-submit");
    },
    async updateAttendanceContentRegisteredModal() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      this.$bvModal.hide("modal-submit");
      let data = {
        attendance_id: this.attendance.attendance_id,
        attendance_type: this.attendanceType,
        attendance_contents: this.attendanceContents,
        user_id: this.$route.params.user_id,
        date: this.$route.params.date,
        request_reason: "",
        is_already_leave_force: ""
      };
      if (
        this.attendanceType === "half_day_leave" ||
        this.attendanceType === "paid_leave" ||
        this.attendanceType === "special_leave" ||
        this.attendanceType === "transfer_leave"
      ) {
        data.request_reason = this.leaveReason;
        data.is_already_leave_force = this.isLeaveForceApproval;
      }
      await this.$store
        .dispatch("ADMIN_ATTENDANCE_UPDATE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.goback();
    },
    goback() {
      this.$router.push({
        path: `/attendance/${this.$route.params.user_id}/user`
      });
    },
    goBeforeDay() {
      this.$router.push({
        path: `/attendance/${this.$route.params.user_id}/user/${dayjs(
          this.$route.params.date
        )
          .add(-1, "days")
          .format("YYYY-MM-DD")}`
      });
      location.reload();
    },
    goAfterDay() {
      this.$router.push({
        path: `/attendance/${this.$route.params.user_id}/user/${dayjs(
          this.$route.params.date
        )
          .add(1, "days")
          .format("YYYY-MM-DD")}`
      });
      location.reload();
    },
    goAttendanceUserDetail() {
      this.$router.push({
        path: `/attendance/${this.$route.params.user_id}/user`
      });
    }
  }
};
